import { AccumulationValues } from "./accumulation";

export enum MedicalCareUsageUnits {
  Visit = "visits",
  Day = "days",
  Unit = "units",
}

export enum MedicalCareUsageNetworks {
  InNetwork = "in_network_tier_1",
  OutOfNetwork = "out_of_network",
}

export interface MedicalCareUsageAccumulationValues extends Pick<AccumulationValues, "max" | "remaining" | "spent"> {
  readonly unit: MedicalCareUsageUnits;
};
